import React from 'react';
import AppRouter from './router';
import { AuthProvider } from './components/Providers/Auth/AuthContext';
import { ProfileProvider } from './Contexts/ProfileContext';

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <AppRouter />
      </ProfileProvider>
    </AuthProvider>
  );
}

export default App;
